import React, { useCallback } from "react";
import { home } from "../data/dummydata";
import Typewriter from "typewriter-effect";
import s from "../../styles/hero.module.css";
import spanish from "../data/images/spanish.png";
import english from "../data/images/english.png.png";

export const Hero = ({ language, setLanguage }) => {
  const toggleLanguage = useCallback(() => setLanguage(!language), [language, setLanguage]);

  const renderLinks = () => (
    <>
      <a href="https://github.com/jmbvdev" target="_blank" rel="noopener noreferrer">
        <i className="fa-brands fa-github"></i>
      </a>
      <a href="https://www.linkedin.com/in/jmbv-dev" target="_blank" rel="noopener noreferrer">
        <i className="fa-brands fa-linkedin"></i>
      </a>
      <a href="https://wa.link/x05vy4" target="_blank" rel="noopener noreferrer">
        <i className="fa-brands fa-whatsapp"></i>
      </a>
    </>
  );

  const renderLanguageSwitcher = () => (
    <div className={s.language} onClick={toggleLanguage}>
      <img src={language ? english : spanish} alt={language ? "Switch to Spanish" : "Switch to English"} />
      <span>{language ? "EN" : "ES"}</span>
    </div>
  );

  const renderDownloadCVButton = () => (
    <a target="_blank" rel="noopener noreferrer" href={language ? "https://drive.google.com/file/d/1Mu-YXWLWGETaffhLgXRsmD0V6qIZQGbp/view?usp=drive_link" : "https://drive.google.com/file/d/1HaknF6Vcls_eJd60CIFi5g0rBVUF7tki/view?usp=sharing"}>
      <button className='primaryBtn' data-aos='fade-up-right'>{language ? "Download CV" : "Descargar CV"}</button>
    </a>
  );

  return (
    <section className='hero'>
      {home.map((val, i) => (
        <div key={i} className='heroContent'>
          <h3 className='fontSize' data-aos='fade-right'>
            {language ? "Hello I'm" : "Hola soy"}
          </h3>
          <h1>
            <Typewriter
              options={{
                strings: [val.name, val.post],
                autoStart: true,
                loop: true,
              }}
            />
          </h1>
          <div className={s.btn_container}>
            {renderLinks()}
          </div>
          <div className={s.btn_hero}>
            {renderLanguageSwitcher()}
            {renderDownloadCVButton()}
          </div>
        </div>
      ))}
    </section>
  );
};
